module.exports = __webpack_public_path__ + "static/img/video_ranking_list_top2.3dab2bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_ranking_list_top2.png
// module id = dxMf
// module chunks = 1